import {
  OPEN_EDIT_MENU_ITEM_DIALOG,
  CLOSE_EDIT_MENU_ITEM_DIALOG,
  SET_MENU_ID,
  UPDATE_MENU_ITEM,
  GET_CATEGORIES,
  GET_MENU,
  REMOVE_MENU_ID,
  STORE_FETURED_IMAGE,
  DELETE_MENU_ITEM,
  SET_IMAGE_LOADING,
  STOP_IMAGE_LOADING,
  UNSET_IMAGE_SUCCESSFULLY_UPLAODED,
  SET_IMAGE_SUCCESSFULLY_UPLAODED
} from "../types";

const initialState = {
  menu: [],
  openEditMenuItemDialog: false,
  imageUploading: false,
  imageSuccessfullyUploaded: false,
  editMenuItemId: null,
  editedMenuItem: {},
  menuUpdate: false,
  categories: [],
};

const cart = {
  name: "pizza",
  price: "80",
  isSizeAvailable: true,
  isCustomizable: true,
  itemType: "VEG",
  sizes: {
    sizeName: "half",
    price: "80",
  },
  customs: [
    {
      heading: "toppings",
      canSelectMultiple: false,
      opt: [
        {
          customItemName: "extra cheese",
          customItemPrice: "30",
        },
        {
          customItemName: "mayonese",
          customItemPrice: "40",
        },
      ],
    },
  ],
};
const menuReducer = (state = initialState, action) => {
  // console.log(action);
  let index = null;
  let tempMenu = [];
  switch (action.type) {
    case GET_MENU:
      return {
        ...state,
        menu: action.payload,
      };

    case OPEN_EDIT_MENU_ITEM_DIALOG:
      return {
        ...state,
        openEditMenuItemDialog: true,
      };

    case CLOSE_EDIT_MENU_ITEM_DIALOG:
      return {
        ...state,
        openEditMenuItemDialog: false,
      };

    case SET_MENU_ID:
      return {
        ...state,
        editMenuItemId: action.payload,
      };

    case REMOVE_MENU_ID:
      return {
        ...state,
        editMenuItemId: null
      }

    case UPDATE_MENU_ITEM:
      return {
        ...state,
        menu: action.payload
      }
    // tempMenu = [...state.menu];
    // index = tempMenu.findIndex((item) => item._id === action.payload.menuItemId);
    // tempMenu[index] = {
    //   ...action.payload.item,
    //   _id: action.payload.menuItemId
    // };
    // return {
    //   ...state,
    //   menu: tempMenu,
    // };

    case GET_CATEGORIES:
      return {
        ...state,
        categories: action.payload
      }

    case STORE_FETURED_IMAGE:
      index = state.menu.findIndex((item) => item._id === action.payload.menuItemId);
      let obj = { ...state.menu[index] };
      return {
        ...state,
        menu: [
          ...state.menu.slice(0, index),
          {
            ...obj,
            featuredImg: action.payload.imageUrl
          },
          ...state.menu.slice(index + 1),
        ]
      }

    case DELETE_MENU_ITEM:
      return {
        ...state,
        menu: state.menu.filter(item => item._id !== action.payload.itemID)
      }

    case SET_IMAGE_LOADING:
      return {
        ...state,
        imageUploading: true,
      }

    case STOP_IMAGE_LOADING:
      return {
        ...state,
        imageUploading: false,
      }

    case UNSET_IMAGE_SUCCESSFULLY_UPLAODED:
      return {
        ...state,
        imageSuccessfullyUploaded: false,
      }

    case SET_IMAGE_SUCCESSFULLY_UPLAODED:
      return {
        ...state,
        imageSuccessfullyUploaded: true,
      }

    default:
      return state;
  }
};

export default menuReducer;

/*

{
    name: "pizza",
    price: "80",
    isSizeAvailable: true,
    isCustomizable: true,
    itemType: "VEG",
    sizes: [
      {
        sizeName: "half",
        price: "80"
      },
      {
        sizeName: "full",
        price: "140"
      }
    ],
    customs: [
      {
        heading: "toppings",
        canSelectMultiple: false,
        opt: [
          {
            customItemName: "extra cheese",
            customItemPrice: "30"
          },
          {
            customItemName: "mayonese",
            customItemPrice: "40"
          }
        ]
      }
    ]
  }
 */

/*
{
    _id: 1,
    name: "Pizza 1",
    category: "food",
    price: "80",
    isFeatured: true,
    isSizeAvailable: true,
    isCustomizable: true,
    itemType: "VEG",
    sizes: [
      {
        sizeName: "half",
        price: "80",
      },
      {
        sizeName: "full",
        price: "140",
      },
    ],
    customs: [
      {
        heading: "toppings",
        canSelectMultiple: false,
        opt: [
          {
            customItemName: "extra cheese",
            customItemPrice: "30",
          },
          {
            customItemName: "mayonese",
            customItemPrice: "40",
          },
        ],
      },
      {
        heading: "Addons",
        canSelectMultiple: true,
        opt: [
          {
            customItemName: "Coca Cola",
            customItemPrice: 20,
          },
          {
            customItemName: "burger",
            customItemPrice: 30,
          },
        ],
      },
    ],
  },
  {
    _id: 2,
    name: "Pizza 2",
    category: "beverage",
    price: "80",
    isFeatured: true,
    isSizeAvailable: true,
    isCustomizable: true,
    itemType: "VEG",
    sizes: [
      {
        sizeName: "half",
        price: "80",
      },
      {
        sizeName: "full",
        price: "140",
      },
    ],
    customs: [
      {
        heading: "toppings",
        canSelectMultiple: false,
        opt: [
          {
            customItemName: "extra cheese",
            customItemPrice: "30",
          },
          {
            customItemName: "mayonese",
            customItemPrice: "40",
          },
        ],
      },
      {
        heading: "Addons",
        canSelectMultiple: true,
        opt: [
          {
            customItemName: "Coca Cola",
            customItemPrice: 20,
          },
          {
            customItemName: "burger",
            customItemPrice: 30,
          },
        ],
      },
    ],
  },
  {
    _id: 3,
    name: "Pizza 3",
    category: "food",
    price: "80",
    isFeatured: true,
    isSizeAvailable: true,
    isCustomizable: true,
    itemType: "VEG",
    sizes: [
      {
        sizeName: "half",
        price: "80",
      },
      {
        sizeName: "full",
        price: "140",
      },
    ],
    customs: [
      {
        heading: "toppings",
        canSelectMultiple: false,
        opt: [
          {
            customItemName: "extra cheese",
            customItemPrice: "30",
          },
          {
            customItemName: "mayonese",
            customItemPrice: "40",
          },
        ],
      },
      {
        heading: "Addons",
        canSelectMultiple: true,
        opt: [
          {
            customItemName: "Coca Cola",
            customItemPrice: 20,
          },
          {
            customItemName: "burger",
            customItemPrice: 30,
          },
        ],
      },
    ],
  },
  {
    _id: 4,
    name: "Pizza 4",
    category: "beverage",
    price: "80",
    isSizeAvailable: true,
    isCustomizable: true,
    itemType: "VEG",
    sizes: [
      {
        sizeName: "half",
        price: "80",
      },
      {
        sizeName: "full",
        price: "140",
      },
    ],
    customs: [
      {
        heading: "toppings",
        canSelectMultiple: false,
        opt: [
          {
            customItemName: "extra cheese",
            customItemPrice: "30",
          },
          {
            customItemName: "mayonese",
            customItemPrice: "40",
          },
        ],
      },
      {
        heading: "Addons",
        canSelectMultiple: true,
        opt: [
          {
            customItemName: "Coca Cola",
            customItemPrice: 20,
          },
          {
            customItemName: "burger",
            customItemPrice: 30,
          },
        ],
      },
    ],
  },
  {
    _id: 5,
    name: "Limited pizza",
    category: "spl",
    price: "100",
    isFeatured: true,
    isSizeAvailable: false,
    isCustomizable: false,
    itemType: "VEG",
  },

*/
